import WalletErrorCodes from "../../errorCodes/Wallet"

export default (code: string) => {
  switch (code) {
    case WalletErrorCodes.RWInsufficientBalance:
      return "errors.PBERRREWWALInsufficientBalance"

    case WalletErrorCodes.RWTooLong:
    case WalletErrorCodes.RWTooLarge:
    case WalletErrorCodes.RWTooSmall:
    case WalletErrorCodes.RWInvalidUnsignedInteger:
    case WalletErrorCodes.RWInvalidCurrencyCode:
    case WalletErrorCodes.RWInvalidUUID:
    case WalletErrorCodes.RWNotUnique:
    case WalletErrorCodes.RWRequired:
    case WalletErrorCodes.TWInvalidArguments:
      return "errors.PBERRInvalidInput"

    case WalletErrorCodes.RWInvalid:
      return "errors.PBERRREWWALInvalid"
    case WalletErrorCodes.RWNotFound:
      return "errors.PBERRREWWALNotFound"

    case WalletErrorCodes.TWAlreadyExists:
      return "errors.PBTWAlreadyExists"

    case WalletErrorCodes.TWNotFound:
      return "errors.PBTWNotFound"

    case WalletErrorCodes.RWForbidden:
      return "errors.PBERRREWWALForbidden"
    case WalletErrorCodes.TWUnauthorized:
      return "errors.PBTWUnauthorized"
    case WalletErrorCodes.TWForbidden:
      return "errors.PBTWForbidden"

    case WalletErrorCodes.TWUnknown:
    case WalletErrorCodes.RWHumanInterventionRequired:
    case WalletErrorCodes.RWMultiError:
    case WalletErrorCodes.RWBadRequest:
    case WalletErrorCodes.RWUnsupportedMediaType:
    case WalletErrorCodes.TWDBPing:
    case WalletErrorCodes.TWHumanInterventionRequired:
    default:
      return ""
  }
}
